import { useRequest } from 'ahooks'
import { Button } from 'antd'
import { toInteger } from 'lodash'

import { queryDealNoticeApi } from '@eastcoal/api/trade/dealNotice/queryDealNotice'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { DealNoticePreviewButtonProps } from './interface'

export const DealNoticePreviewButton = ({
  record
}: DealNoticePreviewButtonProps) => {
  const { status = 0, id = '', title } = record

  const { message } = useFeedback()
  const { previewRef } = useAuctionListStore(state =>
    pick(state, ['previewRef'])
  )

  const { refresh } = useRequest(() => queryDealNoticeApi({ bizIds: [id] }), {
    manual: true,
    onBefore: () => {
      message.loading({ content: '正在加载中....' })
    },
    onSuccess: data => {
      message.destroy()
      setTimeout(() => {
        doPreview(data[0]?.dealNoticeOssId)
      }, 500)
    }
  })

  const doPreview = (dealNoticeOssId?: string) => {
    if (dealNoticeOssId) {
      previewRef.current?.open({
        name: `成交通知书-${title}.pdf`,
        ossId: dealNoticeOssId,
        type: 'pdf'
      })
    } else {
      message.warning('正在生成中,请稍后查看')
    }
  }

  return AuctionMemberPageStatus.DEAL === toInteger(status) ||
    AuctionMemberPageStatus.DEAL_PART === toInteger(status) ? (
    <Button type='link' onClick={refresh}>
      成交通知书
    </Button>
  ) : null
}
